import { render, staticRenderFns } from "./bulk-message-template-create-bulk-message-dialog.vue?vue&type=template&id=29f86ed6&scoped=true&"
import script from "./bulk-message-template-create-bulk-message-dialog.vue?vue&type=script&lang=js&"
export * from "./bulk-message-template-create-bulk-message-dialog.vue?vue&type=script&lang=js&"
import style0 from "./bulk-message-template-create-bulk-message-dialog.vue?vue&type=style&index=0&id=29f86ed6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f86ed6",
  null
  
)

export default component.exports